import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import { getSettingsDetail } from "../Actions/ShippingSettings"


class ShippingSettingsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
    };
  }

  render() {
    const { pageSize, totalRecords, arraylist } = this.props;

    return (
      <div className="" style={{ paddingTop: "12px" }}>

        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          <div className="custom-paginator">
            <Paginator
              className="mb-3"
              first={this.state.first}
              rows={pageSize}
              totalRecords={totalRecords}
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          </div>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">!-- No Items to Display --!</h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="px-3 py-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div
                    className="col-md-11 col-sm-11 col-11  col-lg-11 col-m-auto pt-2 pr-0">
                    <div className="row px-3">
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4 col-md-4 col-lg-4 pb-2"}>
                        <span>
                          <strong>Ship Name : </strong>
                          <span className="italicFont ">{item.shipName} </span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4 col-md-4 col-lg-4 pb-2"}>
                        <span>
                          <strong>To Email : </strong>
                          <span className="italicFont ">
                            {item.toMail === null ? " " : item.toMail.length === 0 ? " " : item.toMail.length > 1 ? item.toMail.reduce(function (a, b) {
                              return (a || a) + ", " + b
                            }) : item.toMail.map((i) => i.toString())}
                          </span>

                        </span>
                      </div>

                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4 col-md-4 col-lg-4 pb-2"}>
                        <span>
                          <strong>CC Email: </strong>
                          <span className="italicFont ">
                            {item.ccMail === null ? " " : item.ccMail.length === 0 ? " " : item.ccMail.length > 1 ? item.ccMail.reduce(function (a, b) {
                              return (a || a) + ", " + b
                            }) : item.ccMail.map((i) => i.toString())}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1 col-sm-1 col-1 col-lg-1 col-m-auto text-right">
                    <i
                      className="fa fa-eye fa-2x click"
                      aria-hidden="true"
                      onClick={() => this.eyeclick(item, item.shipId)}
                      style={{ color: " #1a3464" }}
                    ></i>

                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };

  eyeclick = (item, id) => {
    this.props.dispatch({ type: "ShippingSettingsDetails", data: item });
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch(getSettingsDetail(id));
    this.props.history.push(`/Home/Settings/${id}`);
    window.scrollTo(0, 0);
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,

  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShippingSettingsCard)
);
